import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { UserSpaceMenuService } from '../../_services/app/user-space-menu.service';
import { AuthService } from '../../_services/api/auth.service';
import { MenuItem, SpaceLayoutComponent } from '../../pages-struct/space-layout/space-layout.component';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [RouterOutlet, SpaceLayoutComponent],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.html'
})
export class AdminLayoutComponent implements OnInit {
  userAvatar: string = './assets/images/user-default.png';
  userFirstName: string = '';
  menuItems: MenuItem[] = [];

  constructor(
    private menuService: UserSpaceMenuService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.menuItems = this.menuService.getAdminMenu();
    this.loadUserData();
  }

  private loadUserData() {
    const user = this.authService.getUserInfo();
    if (user) {
      this.userFirstName = user.firstName;
      this.userAvatar = user.avatar || this.userAvatar;
    }
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}